import { PageHeader } from '@fukuri-admins/ui/common';

type Props = {
  /** 利用企業名 */
  clientName: string;
  /** 利用企業一覧ページのURL */
  indexHref: string;
};

/**
 * 利用企業編集ヘッダーの Presentation コンポーネント
 * パンくずリスト付きページヘッダーを表示する
 */
export const EditClientHeaderPresentation: React.FC<Props> = ({ clientName, indexHref }) => (
  <PageHeader
    variant='breadcrumb'
    breadcrumbItems={[{ label: '利用企業', href: indexHref }, { label: `${clientName}の編集` }]}
  />
);
